import { ArchiveIcon } from 'src/modules/common/icons/ArchiveIcon.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

export const NoData = () => (
    <div className="vss-no-data">
        <div className="vss-no-data__container">
            <div className="vss-no-data__icon">
                <ArchiveIcon/>
            </div>

            <h2 className="vss-no-data__title">
                <I18n messageId={MESSAGES.missingDataMessage}/>
            </h2>

            <p className="vss-no-data__description">
                <I18n messageId={MESSAGES.pleaseContact}/>
            </p>
        </div>
    </div>
);
